'use client'
import { useAtom } from 'jotai'

import { ctxIsChangingRoute } from '@docpace/shared-react-atoms'

interface UseIsChangingRouteOutput {
    isChangingRoute: boolean
}

// The App Router has no router.events API; route-change state is tracked via
// the ctxIsChangingRoute atom, which callers can set around navigations
export const useIsChangingRoute: () => UseIsChangingRouteOutput = () => {
    const [ isChangingRoute ] = useAtom(ctxIsChangingRoute)
    return {
        isChangingRoute,
    }
}

export default useIsChangingRoute
